// extracted by mini-css-extract-plugin
export default {"main":"SumCell_main__1cRcS"};